import React, {useEffect, useState} from 'react';

import {withRouter} from 'react-router-dom';

import QaFormComponent from '../../expertDashboardModule/expertSettingsComponent/components/expertRightSettingsComponent/dashboardModuleComponents/widgetSetUpAndInstallationComponent/setUpAndInstallationComponent/components/aiAssistantComponent/qaFormComponent';

import kbResourceService from '../../../services/restServices/kbResourceService';
import utilsService from '../../../services/utilsService';

import VIDABOO_CONSTANTS from '../../../config/consts';

const AiChatMsgImprovementComponent = ({
  context = {},
  messageObj = {},
  onClose = () => {},
  history = {},
}) => {
  const [qaFieldObj, setQaFieldObj] = useState({
    question: '',
    answer: messageObj.messageText || '',
  });

  const [invalidFieldIds, setInvalidFieldIds] = useState([]);
  const [widgetId, setWidgetId] = useState(null);
  const [kbResourceId, setKbResourceId] = useState(null);

  useEffect(() => {
    fetchQuestion();
  }, []);

  const setIsLoading = (isLoaderVisible) => {
    context.setShowHeaderUpdateBar(isLoaderVisible);
  };

  const fetchQuestion = async () => {
    setIsLoading(true);
    const apiResponse = await kbResourceService.createKbResourceQaFromChat(
      messageObj.chatMessageId,
    );
    if (apiResponse.success) {
      console.debug(apiResponse);
      onQuestionReceived(apiResponse);
    } else {
      onErrorReceived(
        'Failed to generate question for the selected response',
        apiResponse.code,
      );
    }
  };

  const onQuestionReceived = (apiResponse) => {
    setQaFieldObj({
      question: apiResponse.data?.question,
      answer: apiResponse.data?.answer,
    });
    setWidgetId(apiResponse.data?.widgetId);
    setKbResourceId(apiResponse.data?.newKbResource?.kbResourceId);
    setIsLoading(false);
  };

  const onErrorReceived = (errorString, errorCode) => {
    const isCreditsError = errorCode === 'CS-002';
    setIsLoading(false);
    const ROUTES = utilsService.getRoutesEnumByImpersonationMode(
      context.isImpersonatedModeActive,
    );
    const toastObj = utilsService.getToastObj({
      toastCustomBtnTxt: isCreditsError ? 'Recharge Credits' : null,
      toastCustomBtnAction: isCreditsError
        ? () => {
            history.push(ROUTES.EXPERT_SETTINGS, {
              navUrl: 'accountSettings/billing/billingAddonsAndUsage',
            });
          }
        : null,
      toastExtraData: isCreditsError
        ? {
            toastSubTitleText:
              'You ran out of credits. Please recharge to continue using Ooni.',
          }
        : null,
      toastTitle: errorString,
      toastType: VIDABOO_CONSTANTS.TOAST_COMPONENT_TYPES.FAILURE,
    });
    context.addToastObj(toastObj);
    onClose();
  };

  const onCompleted = (message) => {
    setIsLoading(false);
    const ROUTES = utilsService.getRoutesEnumByImpersonationMode(
      context.isImpersonatedModeActive,
    );
    const toastObj = utilsService.getToastObj({
      toastLongDuration: true,
      toastCustomBtnTxt: 'Train',
      toastCustomBtnAction: () => {
        history.push(ROUTES.EXPERT_SETTINGS, {
          navUrl:
            'widgetSetup/setUpInstallation/aiAssistant/aiKnowledgeBase/kbResourceQA',
        });
      },
      toastExtraData: {
        toastSubTitleText:
          "You'll still need to train the model to use this information.",
      },
      toastTitle: message,
      toastType: VIDABOO_CONSTANTS.TOAST_COMPONENT_TYPES.SUCCESS,
    });
    context.addToastObj(toastObj);
    onClose();
  };

  const onCancel = () => {
    deleteQaFromKb();
    onClose();
  };

  const getIsAllFieldsValid = () => {
    const isQuestionValid =
      VIDABOO_CONSTANTS.VALIDATION_PATTERNS.QA_QUESTION.test(
        qaFieldObj.question,
      );
    const isAnswerValid = VIDABOO_CONSTANTS.VALIDATION_PATTERNS.QA_ANSWER.test(
      qaFieldObj.answer,
    );
    return isQuestionValid && isAnswerValid;
  };

  const addQaToKB = async () => {
    if (getIsAllFieldsValid()) {
      setIsLoading(true);
      const kbResourceDto = {
        ownerObjectType: VIDABOO_CONSTANTS.BRAIN_OWNER_OBJECT_TYPES.WIDGET,
        ownerObjectId: widgetId,
        type: VIDABOO_CONSTANTS.KBR_TYPES.QA,
        content: {
          question: qaFieldObj.question,
          answer: qaFieldObj.answer,
        },
        status: VIDABOO_CONSTANTS.KBR_STATUSES.INIT,
        splittingMethod: VIDABOO_CONSTANTS.KBR_SPLITTING_METHOD.RECURSIVE,
        parsingMethod: VIDABOO_CONSTANTS.KBR_PARSING_METHOD.MARKDOWNIFY,
        chunkSize: VIDABOO_CONSTANTS.KBR_CHUNK_SIZE,
        kbResourceId: kbResourceId,
      };
      const response = await kbResourceService.updateKBResource(kbResourceDto);
      if (response.success) {
        onCompleted("Question added to Ooni AI's knowledge base");
      } else {
        onErrorReceived(
          "Failed to add question to Ooni AI's knowledge base",
          response.code,
        );
      }
    } else {
      updateInvalidFieldIds(qaFieldObj, true);
    }
  };

  const deleteQaFromKb = async () => {
    if (kbResourceId) {
      const response = await kbResourceService.deleteKBResource(kbResourceId);
      if (response.success) {
        console.debug('Deleted the kbResourceId:', kbResourceId);
      } else {
        console.error('Failed to delete the kbResourceId:', kbResourceId);
      }
    }
  };

  const updateInvalidFieldIds = (qaFieldObj) => {
    let invalidFieldIds = [];
    if (
      !VIDABOO_CONSTANTS.VALIDATION_PATTERNS.QA_QUESTION.test(
        qaFieldObj.question,
      )
    ) {
      invalidFieldIds.push('question');
    }
    if (
      !VIDABOO_CONSTANTS.VALIDATION_PATTERNS.QA_ANSWER.test(qaFieldObj.answer)
    ) {
      invalidFieldIds.push('answer');
    }
  };

  const handleQAFormChanges = (id, value) => {
    let tempInvalidFieldIds = [...invalidFieldIds];
    const invalidFieldIdsQuestionIdx = tempInvalidFieldIds.indexOf('question');
    const invalidFieldIdsAnswerIdx = tempInvalidFieldIds.indexOf('answer');
    let tempQaFieldObj = {...qaFieldObj};
    if (id === 'question') {
      tempQaFieldObj.question = value;
      if (
        !VIDABOO_CONSTANTS.VALIDATION_PATTERNS.QA_QUESTION.test(
          tempQaFieldObj.question,
        )
      ) {
        if (invalidFieldIdsQuestionIdx === -1) {
          tempInvalidFieldIds.push('question');
        }
      } else if (invalidFieldIdsQuestionIdx !== -1) {
        tempInvalidFieldIds.splice(invalidFieldIdsQuestionIdx, 1);
      }
    } else if (id === 'answer') {
      tempQaFieldObj.answer = value;
      if (
        !VIDABOO_CONSTANTS.VALIDATION_PATTERNS.QA_ANSWER.test(
          tempQaFieldObj.answer,
        )
      ) {
        if (invalidFieldIdsAnswerIdx === -1) {
          tempInvalidFieldIds.push('answer');
        }
      } else if (invalidFieldIdsAnswerIdx !== -1) {
        tempInvalidFieldIds.splice(invalidFieldIdsAnswerIdx, 1);
      }
    }
    setQaFieldObj(tempQaFieldObj);
    setInvalidFieldIds(tempInvalidFieldIds);
  };

  if (context.showHeaderUpdateBar) {
    return null;
  }
  return (
    <QaFormComponent
      qaFieldObj={qaFieldObj}
      handleQAFormChanges={handleQAFormChanges}
      invalidFieldIds={invalidFieldIds}
      qaImprovementFlowObject={{
        title: 'Add Q&A to the knowledge base',
        subTitle:
          "This adds the Q&A to your knowledge base. You'll still need to train the model afterward for it to use this information.",
        leftBtnTxt: 'Discard',
        rightBtnTxt: 'Accept',
        leftBtnAction: onCancel,
        rightBtnAction: addQaToKB,
      }}
    />
  );
};

export default withRouter(AiChatMsgImprovementComponent);
